import React from 'react';
import { ConfirmarEntrarEmContatoModalConsumer } from './ConfirmarEntrarEmContatoModalConsumer';

export const withConfirmarEntrarEmContatoModal = Component => props => (
  <ConfirmarEntrarEmContatoModalConsumer>
    <Component {...props} />
  </ConfirmarEntrarEmContatoModalConsumer>
);
